/* eslint-disable no-unused-vars */
import magnificPopup from 'magnific-popup';
import Cookies from 'js-cookie';

export default () => {
  const $modal = $('.modal');
  const $btn = $('.modal .modal-cta .btn');

  if ($modal.length) {
    const cookieExpiration = $modal.data('cookie-expiration');

    if (!sessionStorage.getItem('asce-alert-modal-dismissed')) {
      $.magnificPopup.open({
        mainClass: 'mfp-fade',
        midClick: true,
        removalDelay: 200,
        items: {
          src: $modal,
          type: 'inline'
        },
        callbacks: {
          close() {
            if (cookieExpiration > 0) {
              Cookies.set('asce_modal_cookie', 'true', { expires: cookieExpiration });
            } else {
              Cookies.set('asce_modal_cookie', 'true');
            }
          }
        }
      });
    }

    $btn.on('click', (e) => {
      e.preventDefault();

      if (cookieExpiration > 0) {
        Cookies.set('asce_modal_cookie', 'true', { expires: cookieExpiration });
      } else {
        Cookies.set('asce_modal_cookie', 'true');
      }

      location.href = $btn.attr('href');
    });
  }
};
